import React from 'react';
import styled, { css } from 'styled-components';
import { media, spaces } from '../../../../shared/lib/styles';

export interface Props {
    src: string;
    alt: string;
    attribution: string;
    xPos: number;
    yPos: number;
    parallaxY?: number[];
}

const smallEntrySize = '250px';
const largeEntrySize = '287px';

const entryTransform = [
    [-620, -160],
    [-70, 0],
    [362, -60],
    [-640, 620],
    [410, 830],
    [480, 350],
    [-740, 1150],
    [240, 1240],
    [-10, 1620],
    [-600, 1860],
];

export const StyledEntry = styled.div<{ index: number }>(({ index }) => {
    return css`
        display: inline-block;

        @media ${media('small', 'medium')} {
            width: ${smallEntrySize};
            margin-left: ${spaces.halfGutter}px;
            margin-right: ${spaces.halfGutter}px;
        }

        @media ${media('normal', 'large')} {
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: ${largeEntrySize};
            height: ${largeEntrySize};
            transform: translate(${entryTransform[index][0]}px, ${entryTransform[index][1]}px);
        }
    `;
});

export const StyledEntries = styled.div<{
    asPlaceholders: boolean;
    withLargeStats: boolean;
    isIE11: boolean;
}>(({ asPlaceholders, withLargeStats, isIE11 }) => {
    return css`
        position: relative;
        white-space: nowrap;

        @media ${media('normal', 'large')} {
            width: 1px;
            height: ${largeEntrySize};
            margin-left: auto;
            margin-right: auto;
        }

        @media ${media('small', 'medium')} {
            text-align: center;
            overflow: scroll;
            ${asPlaceholders &&
            css`
                display: none;
            `}
        }

        ${StyledEntry} {
            &:nth-child(4) {
                ${asPlaceholders &&
                css`
                    transform: translate(-730px, ${entryTransform[3][1]}px);
                `}
                ${withLargeStats &&
                css`
                    transform: translate(-760px, 660px);
                `}
            }
            &:nth-child(5) {
                ${asPlaceholders &&
                css`
                    transform: translate(80px, ${entryTransform[4][1]}px);
                `}
            }
        }

        ${isIE11 &&
        css`
            ${asPlaceholders &&
            css`
                display: none;
            `}

            @media ${media('normal', 'large')} {
                text-align: center;
                overflow: scroll;
                width: 100%;
                height: 100%;

                ${StyledEntry} {
                    height: 100%;
                    position: relative;
                    transform: none !important;
                    width: ${smallEntrySize};
                    margin-left: ${spaces.halfGutter}px;
                    margin-right: ${spaces.halfGutter}px;
                }
            }
        `}
    `;
});

export default StyledEntries;
